@if (displayBanner()) {
  <div class="p-3">
    <p-message styleClass="w-full" severity="warn">
      <ng-template #container>
        <div class="grid flex-column w-full">
          <div class="flex items-center align-items-start gap-2 font-medium">
            <osf-icon iconClass="fas fa-triangle-exclamation"></osf-icon>
            {{ 'toast.cookie-consent.message' | translate }}
          </div>
          <div class="row-fixed flex justify-content-end">
            <p-button
              class="btn-link-dark-blue"
              link
              [label]="'toast.cookie-consent.accept' | translate"
              (onClick)="acceptCookies()"
            />
          </div>
        </div>
      </ng-template>
    </p-message>
  </div>
}
